import Styles from "./styles.js";

import { Icon, Timeline } from 'rsuite';

import PropTypes from 'prop-types';
import React from 'react';

const renderItem = ({ date, email, name, text, icon }) => {
  return (
    <Timeline.Item key={date} dot={<Icon icon={icon} size="2x" />}>
      <p className="date">{date}</p>
      <p className="text">{name}</p>
      <p className="text">{email}</p>
      <p className="text">{text}</p>
    </Timeline.Item>
  );
};

function TimelineComponent({ items, ...props }) {
  return (
    <>
    <Timeline {...props} className="sr-timeline">
      {items.map(t => renderItem(t))}
    </Timeline>
    <Styles/>
    </>
  );
}

TimelineComponent.propTypes = {
  children: PropTypes.node,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      text: PropTypes.node.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ),
};

export default TimelineComponent;
